/*=============================================== SrOnlyPage ===============================================*/

import { SrOnly, Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType } from "components"

const SrOnlyPage = () => {
    const items: ItemType[] = [
        {
            title: "With a component",
            content: <SrOnly as="h2">Sr only title</SrOnly>,
            code: '<SrOnly as="h2">Sr only title</SrOnly>',
        },
        {
            title: "With a class",
            content: (
                <Text tag="h2" className="sr-only">
                    Sr only title
                </Text>
            ),
            code: '<Text tag="h2" className="sr-only">Sr only title</Text>',
        },
    ]

    return <ComponentsLayout items={items} propsItems={[]} />
}

export default SrOnlyPage
